module.exports = __webpack_public_path__ + "img/Blog-Image.405a1aa6.png";